import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  Signal,
} from '@angular/core';
import { NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { MultimediaTileBoxComponent } from '../multimedia-tile-box/multimedia-tile-box.component';
import { ImageThumbnailComponent } from '@web/shared/ui';
import { MultimediaTileThumbnailFilling } from '../../types/multimedia-tile-thumbnail-filling';
import { MultimediaTileBoxRemoveButtonComponent } from '../multimedia-tile-box-remove-button/multimedia-tile-box-remove-button.component';

@Component({
  selector: 'app-multimedia-tile-thumbnail',
  imports: [
    MultimediaTileBoxComponent,
    ImageThumbnailComponent,
    NgOptimizedImage,
    MultimediaTileBoxRemoveButtonComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './multimedia-tile-thumbnail.component.html',
  styleUrl: './multimedia-tile-thumbnail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaTileThumbnailComponent {
  public readonly filling = input<MultimediaTileThumbnailFilling>('contain');
  public readonly alt = input.required<string>();
  public readonly url = input.required<string>();
  public readonly withRemoveEvent = input<boolean>(false);
  public readonly withClickEvent = input<boolean>(true);

  public readonly clickEvent = output<void>();
  public readonly removeClickEvent = output<void>();

  /* prettier-ignore */
  protected readonly previewFillingCssClass = this.previewFillingCssClassSignal();

  protected handleClickEvent(): void {
    this.clickEvent.emit();
  }

  protected handleRemoveClickEvent(): void {
    this.removeClickEvent.emit();
  }

  private previewFillingCssClassSignal(): Signal<string> {
    return computed(() => {
      switch (this.filling()) {
        case 'contain':
          return 'object-contain';

        case 'cover':
          return 'object-cover';

        default:
          return '';
      }
    });
  }
}
